import { useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'

import { setLanguageAction } from 'root-redux/actions/common'
import {
  selectCurrentVariant,
  selectCurrentVariantCohort,
  selectIsInContextShown,
} from 'root-redux/selects/common'

import { getEnvironment } from 'helpers/getEnvironment'

import { browserHistory } from 'browser-history'
import {
  Cohort,
  INITIAL_LANGUAGE,
  LANG_QUERY_PARAM,
  Language,
  SUPPORTED_LOCALES_MAP,
} from 'root-constants'

export const useLanguage = (): void => {
  const { pathname, search } = document.location
  const dispatch = useDispatch()
  const variant = useSelector(selectCurrentVariant, shallowEqual)
  const cohort = useSelector(selectCurrentVariantCohort)
  const isInContextShown = useSelector(selectIsInContextShown)

  const { isStageEnvironment } = getEnvironment()

  const isInContextActive = isStageEnvironment && isInContextShown

  useEffect(() => {
    if (!variant) return

    const URLParams = new URLSearchParams(search)
    const langQueryParam = URLParams.get(LANG_QUERY_PARAM) || ''
    const supportedLocales = SUPPORTED_LOCALES_MAP[cohort as Cohort] || [
      INITIAL_LANGUAGE,
    ]

    const isSupportedLang = supportedLocales.includes(langQueryParam)

    const langValue = isSupportedLang ? langQueryParam : INITIAL_LANGUAGE
    const finalLang = isInContextActive ? Language.IN_CONTEXT : langValue

    dispatch(setLanguageAction(finalLang))

    if (!isSupportedLang) {
      URLParams.set(LANG_QUERY_PARAM, INITIAL_LANGUAGE)
      browserHistory.replace({
        pathname,
        search: URLParams.toString(),
      })
    }
  }, [cohort, dispatch, isInContextActive, pathname, search, variant])
}
